import { gql } from 'apollo-boost'

export const DASHBOARD = gql`
  query dashboard {
    response: dashboard
  }
`
